import script from "./LandingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingView.vue?vue&type=script&setup=true&lang=ts"

import "./LandingView.vue?vue&type=style&index=0&id=f1debfe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1debfe8"]])

export default __exports__